import { render } from "./LayersTwoIcon.vue?vue&type=template&id=2f48c5db"
import script from "./LayersTwoIcon.vue?vue&type=script&lang=js"
export * from "./LayersTwoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__